module.exports = __webpack_public_path__ + "static/media/step3_br.20563a24.png";